module.exports = __webpack_public_path__ + "img/a08.c9ab6ad9.png";